import { render } from "./AttendanceAdjustmentCommentsModal.vue?vue&type=template&id=d1760fc0&scoped=true"
import script from "./AttendanceAdjustmentCommentsModal.vue?vue&type=script&lang=js"
export * from "./AttendanceAdjustmentCommentsModal.vue?vue&type=script&lang=js"

import "@/orangehrmLeavePlugin/components/leave-comment-modal.scss?vue&type=style&index=0&id=d1760fc0&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1760fc0"]])

export default __exports__